import { MotionDiv } from '@/shared/components/motion-div';
import { cn } from '@/shared/utils/cn';

export function SettingSectionLayout({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <MotionDiv className={cn('flex w-full max-w-3xl flex-col', className)}>{children}</MotionDiv>
  );
}
